/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, {Component} from 'react';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Places from '../../containers/places.js';
import PropTypes from 'prop-types';

class Management extends Component {

  constructor(props) {
    super(props);
  }


  render() {
    return (
      <div>
        <SidebarMenuRouters profile="/profile-management/place/" place=""/>
        <Header profileName="Gerencia"/>
        <Places profile="/profile-management/place/"/>
      </div>
    );
  }
}

export default Management;



// WEBPACK FOOTER //
// ./src/scene/profile/management.js